<template>
  <div class="app">
      <v-card>
        <!-- <v-btn small color="success" @click="check">Check</v-btn> -->
        <v-container fluid grid-list-lg>
          <div v-bind="data" class="font-weight-thin title">Ques: {{data.question}}</div>
          <v-layout row v-if="this.multiple_ans ==1">
            <v-flex xs6>
              <v-card-title class="title">Frequency Table</v-card-title>
                <v-data-table
                    :headers="headers2"
                    :items="project_budget2"
                    hide-actions
                    :expand="true"
                    :disable-initial-sort="true"
                    class="elevation-1"
                    dark
                >
                    <template v-slot:items="props">
                    <td>{{ props.item.option }}</td>
                    <td class="text-xs-right">{{props.item.count}}</td>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex xs6>
              <v-card-title class="title">Bar Chart</v-card-title>
                <VueApexCharts type="bar" height="350" :options="chart.bar.chartOptions" :series="chart.bar.series"></VueApexCharts>
            </v-flex>
          </v-layout>
          <v-layout row v-else>
            <v-flex xs6>
              <v-card-title class="title">Frequency Table</v-card-title>
                <v-data-table
                    :headers="headers"
                    :items="project_budget"
                    hide-actions
                    :expand="true"
                    :disable-initial-sort="true"
                    class="elevation-1"
                    dark
                >
                    <template v-slot:items="props">
                    <td>{{ props.item.option }}</td>
                    <td class="text-xs-right">{{ props.item.count }}</td>
                    <td class="text-xs-right">{{ props.item.percent}}</td>
                    </template>
                </v-data-table>
            </v-flex>
            <v-flex xs6 v-if="total_option > 5">
              <v-card-title class="title">Bar Chart</v-card-title>
                <VueApexCharts
                type="bar"
                height="360"
                :options="chart.bar.chartOptions"
                :series="chart.bar.series"
                ></VueApexCharts>
            </v-flex>
            <v-flex xs6 v-else>
              <v-card-title class="title">Pie Chart</v-card-title>
                <VueApexCharts
                type="pie"
                height="300"
                :options="chart.pie.options"
                :series="chart.pie.series"
                ></VueApexCharts>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  props:['dataset'],
  name: "Chart",
  components: {
    VueApexCharts,
  },
  data: function() {
    return {
        multiple_ans: null,
        total_option: null,
        data:{
          question_id:null,
          ui_category_id:null,
          question:null
        },
        headers: [
            { text: "Option", value: "option", sortable: false, class: "title success white--text"},
            { text: "Count", value: "count", align: "right", class: "title success white--text" },
            { text: 'Ptg (%)', value: 'percentage', align: 'right', class: "title success white--text" },
        ],
        headers2: [
            { text: "Option", value: "option", sortable: false, class: "title success white--text"},
            { text: "Count", value: "count", align: "right", class: "title success white--text" },
        ],
        project_budget: [],
        project_budget2: [],
        chart: {
        pie: {
            series: [],
            options: {
                // title: {
                // text: "Dasher Age Overview",
                // },
                noData: {
                text: "No data available",
                },
                chart: {
                type: "pie",
                toolbar: {
                    show: true,
                },
                },
                labels: [],
                colors: [
                "#9C27B0",
                "#71974c",
                "#d34626",
                "#3E2723"
                ],
                legend: {
                show: true,
                position: "bottom",
                },
            },
        },
        bar: {
          series: [{
            data: []
          }],
          chartOptions: {
            noData: {
              text: "No data available",
            },
            chart: {
              type: 'bar',
              height: 350
            },
            plotOptions: {
              bar: {
                borderRadius: 4,
                horizontal: false,
              }
            },
            dataLabels: {
              enabled: false
            },
            xaxis: {
              categories: [],
            }
          },
        }
      }
    }; 
  },

  watch: {
    dataset: function(){
      this.initialize()  
    }
  },

  created () {
      this.initialize()
  },

  methods: {
      initialize () {
        let multiple_ans = this.dataset.queSet.multiple_answer,
        total_option = this.dataset.queSet.total_option;

        if ((total_option < 6) && (multiple_ans !=1)) {
          this.chart.pie.options = {
            labels: this.dataset.graphData.labels,
          };
          this.chart.pie.series=this.dataset.graphData.series;
          this.project_budget=this.dataset.datas;
          this.project_budget2=this.dataset.datas;
          this.multiple_ans = this.dataset.queSet.multiple_answer
          this.total_option = this.dataset.queSet.total_option
          this.data.question = this.dataset.queSet.question
        }else{
          this.chart.bar.chartOptions = {
            xaxis:{
              categories: this.dataset.graphData.labels
            }
          };
          this.chart.bar.series=[{
            data:this.dataset.graphData.series
          }];
          this.project_budget2=this.dataset.datas;
          this.project_budget=this.dataset.datas;
          this.multiple_ans = this.dataset.queSet.multiple_answer
          this.total_option = this.dataset.queSet.total_option
          this.data.question = this.dataset.queSet.question
        }
      },
      // check(){
      //   // this.multiple_ans = this.dataset.queSet.multiple_ans
      //   // this.multiple_ans = this.dataset.queSet.total_option
      //   // this.chart.age.options = {
      //   //   labels: this.dataset.pieChart.labels,
      //   // };
      //   // this.chart.age.series=this.dataset.pieChart.series;
      //   // console.log(this.dataset);
      //   // console.log(this.chart.pie.options);
      // }
  }
};
</script>

<style>
#chart3 {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
